"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllFraktAccounts = void 0;
const helpers_1 = require("../../helpers");
const helpers_2 = require("../../helpers");
const getAllPerpetualProgramAccounts_1 = require("./getAllPerpetualProgramAccounts");
const getAllFraktAccounts = (programId, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const program = yield (0, helpers_2.returnAnchorProgram)(programId, connection);
    const fraktBondsOffset = 8;
    const fraktBondsRaw = yield (0, getAllPerpetualProgramAccounts_1.getFilteredAccounts)(program, 'fraktBond', fraktBondsOffset, [0, 1, 2, 3, 4]);
    const fraktBonds = fraktBondsRaw.map((fraktBondRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(fraktBondRaw));
    const collateralBoxOffset = 32 + 1 + 32 + 32 + 8;
    const collateralBoxesRaw = yield (0, getAllPerpetualProgramAccounts_1.getFilteredAccounts)(program, 'collateralBox', collateralBoxOffset, [1]);
    const collateralBoxes = collateralBoxesRaw.map((collateralBoxRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(collateralBoxRaw));
    const hadoMarketRegistry = (yield program.account.hadoMarketRegistry.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const hadoMarketOffset = 32 + 8;
    const hadoMarketsRaw = yield (0, getAllPerpetualProgramAccounts_1.getFilteredAccounts)(program, 'hadoMarket', hadoMarketOffset, [0, 1]);
    const hadoMarkets = hadoMarketsRaw.map((hadoMarketRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(hadoMarketRaw));
    const bondOfferOffset = 32 + 8;
    const bondOffersV2Raw = yield (0, getAllPerpetualProgramAccounts_1.getFilteredAccounts)(program, 'bondOfferV2', bondOfferOffset, [1]);
    const bondOffersV2 = bondOffersV2Raw.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc));
    const bondTradeTxnOffset = 8;
    const bondTradeTxnRaw = yield (0, getAllPerpetualProgramAccounts_1.getFilteredAccounts)(program, 'bondTradeTransactionV2', bondTradeTxnOffset, [0, 1]);
    const bondTradeTransactionsV2 = bondTradeTxnRaw.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc)).filter((tradetxn) => tradetxn.publicKey !== 'CmFdBaFUGPvsV8Cs5AGRVwLFav3c2ptzEeXvhwP9UD9m');
    return {
        bondTradeTransactionsV2,
        bondOffersV2,
        fraktBonds,
        collateralBoxes,
        hadoMarketRegistry,
        hadoMarkets,
    };
});
exports.getAllFraktAccounts = getAllFraktAccounts;
